import { enqueueLog } from './logBatcher'

// Optional user context for enriching logs
let userContext = null
export function setLogUserContext(user) {
  userContext = user
}

function serializeAny(arg) {
  if (arg instanceof Error) {
    return {
      type: 'Error',
      name: arg.name,
      message: arg.message,
      stack: arg.stack,
      ...(arg.isAxiosError ? { isAxiosError: true } : {}),
    }
  }
  if (typeof arg === 'object' && arg !== null) {
    try {
      return JSON.parse(JSON.stringify(arg))
    } catch {
      return { type: 'UnserializableObject', value: String(arg) }
    }
  }
  return arg
}

// Thin wrapper that enriches payload, then forwards to logBatcher
function pushLog(log) {
  const enriched = {
    ...log,
    url: window.location.href,
    userAgent: navigator.userAgent,
    ...(userContext
      ? {
          userId: userContext.id,
          userName: userContext.name,
          role: userContext.role,
        }
      : {}),
    timestamp: new Date().toISOString(),
  }

  enqueueLog(enriched)
}

export function initGlobalErrorHandlers() {
  function serializeError(err) {
    if (!err) return null

    const serialized = {
      name: err.name,
      message: err.message,
      stack: err.stack,
    }

    if (err.isAxiosError) {
      serialized.isAxiosError = true
      if (err.config) {
        serialized.config = {
          method: err.config.method,
          url: err.config.url,
          headers: err.config.headers,
          data:
            typeof err.config.data === 'object'
              ? JSON.stringify(err.config.data)
              : err.config.data,
        }
      }
      if (err.response) {
        serialized.response = {
          status: err.response.status,
          statusText: err.response.statusText,
          headers: err.response.headers,
          data:
            typeof err.response.data === 'object'
              ? JSON.stringify(err.response.data)
              : err.response.data,
        }
      }
      if (err.request && !err.response) {
        serialized.request = {
          readyState: err.request.readyState,
          status: err.request.status,
          statusText: err.request.statusText,
        }
      }
    }

    return serialized
  }

  function pushErrorLog(args) {
    const errObj = args.find((a) => a instanceof Error)
    const serializedArgs = args.map(serializeAny)

    pushLog({
      level: 'error',
      message: args
        .map((a) => (a instanceof Error ? a.message : String(a)))
        .join(' '),
      error: serializeError(errObj),
      stack: errObj?.stack || null,
      consoleArgs: serializedArgs,
    })
  }

  window.onerror = (message, source, lineno, colno, error) => {
    pushLog({
      level: 'error',
      message: message?.toString(),
      error: serializeError(error),
      stack: error?.stack || null,
      source,
      lineno,
      colno,
    })
  }

  window.onunhandledrejection = (event) => {
    const reason =
      event.reason instanceof Error ? event.reason : new Error(String(event.reason))
    pushLog({
      level: 'error',
      message: reason.message,
      error: serializeError(reason),
      stack: reason.stack || null,
    })
  }

  const originalConsoleError = console.error
  console.error = (...args) => {
    pushErrorLog(args)
    originalConsoleError.apply(console, args)
  }

  // Flush a final marker before navigating away
  window.addEventListener('beforeunload', () => {
    enqueueLog({ level: 'info', message: 'flush' })
  })
}
